webpackJsonp([263791100135453],{

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.OutboundLink = undefined;
	
	var _extends2 = __webpack_require__(30);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OutboundLink(props) {
	  return _react2.default.createElement("a", (0, _extends3.default)({}, props, {
	    onClick: function onClick(e) {
	      var redirect = true;
	      if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || e.defaultPrevented) {
	        redirect = false;
	      }
	      if (props.target && props.target.toLowerCase() !== "_self") {
	        redirect = false;
	      }
	      if (window.ga) {
	        window.ga("send", "event", {
	          eventCategory: "Outbound Link",
	          eventAction: "click",
	          eventLabel: props.href,
	          transport: redirect ? "beacon" : "",
	          hitCallback: function hitCallback() {
	            if (redirect) {
	              document.location = props.href;
	            }
	          }
	        });
	      } else {
	        if (redirect) {
	          document.location = props.href;
	        }
	      }
	
	      return false;
	    }
	  }));
	}
	
	OutboundLink.propTypes = {
	  href: _propTypes2.default.string,
	  target: _propTypes2.default.string
	};
	
	exports.OutboundLink = OutboundLink;

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var Url = "//s.gravatar.com/avatar";
	  var Hash = "90fd4cc7a8a2b5c469a921a14369a1ac";
	  var Size = 280;
	
	  return _react2.default.createElement("img", _extends({ src: Url + "/" + Hash + "?s=" + Size,
	    size: Size,
	    alt: "Gravatar",
	    className: "gravatar" }, props));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyPluginGoogleAnalytics = __webpack_require__(28);
	
	var _Container = __webpack_require__(23);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Heading = __webpack_require__(18);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Gravatar = __webpack_require__(220);
	
	var _Gravatar2 = _interopRequireDefault(_Gravatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bio = function Bio(props) {
	  return _react2.default.createElement(
	    'div',
	    _extends({ id: 'about-bio', className: 'grid-wrap' }, props),
	    _react2.default.createElement(
	      'div',
	      { className: 'grid grid--gutters sm-grid--full' },
	      _react2.default.createElement(
	        'div',
	        { className: 'grid-cell u-1of3 u-sm-full' },
	        _react2.default.createElement(_Gravatar2.default, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'grid-cell' },
	        props.children
	      )
	    )
	  );
	};
	
	var Experience = function Experience(props) {
	  return _react2.default.createElement(
	    'div',
	    _extends({ id: 'about-experience', className: 'grid-wrap' }, props),
	    _react2.default.createElement(
	      _Heading2.default,
	      { level: '3' },
	      'Experience'
	    ),
	    props.children
	  );
	};
	
	var Position = function Position(props) {
	  var title = props.title,
	      company = props.company;
	
	  var years = props.end ? props.start + ' — ' + props.end : props.start;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'about-position grid grid--gutters grid--separator sm-grid--full' },
	    _react2.default.createElement(
	      'div',
	      { className: 'grid-cell u-1of3 u-sm-full' },
	      years
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'grid-cell' },
	      _react2.default.createElement(
	        _Heading2.default,
	        { level: '4' },
	        title
	      ),
	      _react2.default.createElement(
	        _Heading2.default,
	        { level: '5' },
	        company
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        props.children
	      )
	    )
	  );
	};
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var meta = data.site.siteMetadata;
	  var pageTitle = "About";
	  var siteTitle = pageTitle + ' \u2014 ' + meta.title;
	
	  return _react2.default.createElement(
	    _Container2.default,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      { title: pageTitle },
	      _react2.default.createElement('meta', { property: 'og:title', content: siteTitle })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'header-wrap' },
	      _react2.default.createElement(
	        _Heading2.default,
	        { level: '2', className: 'grid-wrap' },
	        pageTitle
	      )
	    ),
	    _react2.default.createElement(
	      Bio,
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Jorge Mancheno is a product designer and front-end developer based in Brooklyn, NY. He\'s known for his love of Apple products, extensive sneaker collection, and appreciation of Marvel movies/shows.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Jorge thrives in a collaborative environment. He\'s worked with various development teams over the years to bring early concepts from an initial prototype/wireframe stage to fully polished consumer and enterprise products. A designer first, Jorge also enjoys bringing ideas to life with production ready HTML, CSS, and on occasion JS.'
	      ),
	      _react2.default.createElement(
	        'h5',
	        { className: 'heading' },
	        'The Site'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'This version of the site was built from scratch using ',
	        _react2.default.createElement(
	          _gatsbyPluginGoogleAnalytics.OutboundLink,
	          { href: 'https://www.gatsbyjs.org/', className: 'link-external', target: '_blank' },
	          'Gatsby'
	        ),
	        ' and is hosted at ',
	        _react2.default.createElement(
	          _gatsbyPluginGoogleAnalytics.OutboundLink,
	          { href: 'https://www.digitalocean.com/', className: 'link-external', target: '_blank' },
	          'DigitalOcean'
	        ),
	        '. You can view it\'s source code on ',
	        _react2.default.createElement(
	          _gatsbyPluginGoogleAnalytics.OutboundLink,
	          { href: 'https://github.com/jorgemancheno/jorgemancheno.com', className: 'link-external', target: '_blank' },
	          'GitHub'
	        ),
	        '.'
	      )
	    ),
	    _react2.default.createElement(
	      Experience,
	      null,
	      _react2.default.createElement(
	        Position,
	        { start: '2013', end: '2017',
	          title: 'Principle UI Designer',
	          company: 'AOL Inc' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Designed AOL\'s replacement for Google Reader which included a marketing site, and responsive web/mobile versions of the RSS reader interface. The responsive web interface and feature set was constantly evolving based on user feedback, and later versions adopted a more modern look and feel.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Designed adaptive web interfaces for AOL\'s Content Hub platform which was an enterprise-ready set of tools for creating, consuming, and monetizing publisher content. Developed and maintained guidelines for every interface component used in the platform. Led efforts to have other products under the AOL Publishers umbrella adopt the look and feel used by Content Hub.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Lead design for a news consumption app built for iOS and Android that featured the ability to create custom news channels a user could follow and share with other users, built-in chat, and alarm clock functionality. Worked with an outside vendor to iterate through the design and helped oversee its development.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Worked closely with the Athena product team on the Athena Content Services platform, a reimagining of AOL Publishers. Lead design for the platform as a whole, helped develop the Athena Owl branding, and consulted on the marketing site. Designed and developed an HTML/CSS framework for the Athena suite of products.'
	        )
	      ),
	      _react2.default.createElement(
	        Position,
	        { start: '2010', end: '2013',
	          title: 'Senior UI Designer',
	          company: 'AOL Inc / Pictela Inc' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Iterated on the design of Pictela\'s ad formats following the company\'s acquisition by AOL Inc in late-2010. Creative direction for AOL\'s Project Devil ad format was taken over, and an overall visual treatment for all of the supported ad units was established. Styleguides defining each ad format\'s configuration and best use practices were created and later distributed to publishers looking to adopt Pictela ads. Consulted on the design of additional ad units later on.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Designed and contributed to the development of version 3 of the Pictela Management Console. Work included the design of workflows used for managing campaigns, assets, ad units, and a tool that generated exportable reports based on user input.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Designed Pictela\'s updated branding which was used on the web and in print. As part of the rebranding, Pictela\'s marketing site was redesigned and rebuilt from scratch. Also designed a few t-shirts that incorporated the updated branding.'
	        )
	      ),
	      _react2.default.createElement(
	        Position,
	        { start: '2010',
	          title: 'Senior Designer',
	          company: 'Pictela Inc' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Designed an updated visual treatment for Pictela\'s initial ad template offering based on standard IAB sizes, and an early visual treatment for version 2 of the Pictela Management Console, which was used to create and manage ad units on the platform prior to the company\'s acquisition by AOL Inc in late-2010.'
	        )
	      ),
	      _react2.default.createElement(
	        Position,
	        { start: '2007', end: '2010',
	          title: 'Senior Visual/Web Designer',
	          company: 'Lime Wire LLC' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Designed and developed much of LimeWire\'s online marketing site (LimeWire.com), and it\'s developer-friendly portal (LimeWire.org). Work on LimeWire.com included overall creative direction, design of marketing materials, and front-end development of most of the site. LimeWire.org featured custom designed and built themes for its blog (Wordpress), user forums (vBulletin), and wiki (MediaWiki).'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Designed and contributed to the development of the promotional platform used within the LimeWire P2P client. Designed materials meant to educate LimeWire\'s users on advanced and Pro features, which were seen by thousands of users daily. Also designed the custom icon set and splash screens used in version 5 of the LimeWire P2P client.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Worked with the rest of the in-house design team on Grapevine, an unreleased online music streaming service similar to Apple Music and Spotify. Designed wireframes for several portions of the service, and multiple visual treatments for the application. Also contributed to the development of an HTML5 prototype used for testing of designed components.'
	        )
	      ),
	      _react2.default.createElement(
	        Position,
	        { start: '2006', end: '2007',
	          title: 'Visual/Web Designer',
	          company: 'Lime Spot LLC' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Worked as part of a small team early on that was building a social networking site targeting independent music artists to help them establish an online presence. Designed the user interface of the LimeSpot web application including a custom icon set used throughout, and aided in its front-end development. Also designed themes meant to be used by LimeSpot-powered sites.'
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-50bf582943d3b5eca31f.js